import { Form, Modal } from "antd";
import React from "react";
import { CreateDropPeriodDto } from "../../../api";
import { DropPeriodColumns } from "../form/columns";

interface DropPeriodFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateDropPeriod: (values: CreateDropPeriodDto) => void;
}

export const DropPeriodForm: React.FC<DropPeriodFormProps> = ({ visible, setVisible, onCreateDropPeriod }) => {
  const [form] = Form.useForm<CreateDropPeriodDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateDropPeriod}>
        {DropPeriodColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
